import type { FormFlow, FmpFormStep } from '../../../types/form'
import { addressAndMover } from '../questions/addressAndMover'
import { interstitial } from '../questions/interstitial'
import { homeInfo } from '../questions/homeInfo'
import { email } from '../questions/email'
import { texasMove } from '../questions/texasMove'
import { monthlyEnergy } from '../questions/monthlyEnergy'
import { householdIncludes } from '../questions/householdIncludes'
import { vehicleCharge } from '../questions/vehicleCharge'
import { energyPlanIncludes } from '../questions/energyPlanIncludes'
import { termChoice } from '../questions/termChoice'
import { uploadBill } from '../questions/uploadBill'

export const FMP_FORM_NAME = 'fmp_v1'

export const createDefaultQuiz = (): FormFlow => {
  // Overrides - Apply interstitial-based logic via overrides
  const monthlyEnergyQuestion = {
    ...monthlyEnergy,
    coreIf: 'interstitial = deepDive',
    visibleIf: 'interstitial = deepDive',
  }

  const householdIncludesQuestion = {
    ...householdIncludes,
    coreIf: 'interstitial = deepDive',
    visibleIf: 'interstitial = deepDive',
  }

  const vehicleChargeQuestion = {
    ...vehicleCharge,
    coreIf: {
      operator: '&&',
      conditions: [
        'interstitial = deepDive',
        {
          formStepKey: 'householdIncludes',
          comparisonOperator: 'includes',
          expectedAnswer: 'electricVehicle',
        },
      ],
    },
  }

  const termChoiceQuestion = {
    ...termChoice,
    coreIf: 'interstitial = deepDive',
    visibleIf: 'interstitial = deepDive',
  }

  const uploadBillQuestion = {
    ...uploadBill,
    visibleIf: 'interstitial = deepDive',
  }

  const fmpFormQuestions: FmpFormStep[] = [
    interstitial,
    addressAndMover,
    homeInfo,
    texasMove,
    monthlyEnergyQuestion,
    householdIncludesQuestion,
    vehicleChargeQuestion,
    energyPlanIncludes,
    termChoiceQuestion,
    uploadBillQuestion,
    email,
  ]

  /**
   * The main form flow configuration for Find My Plan
   * Contains version information and all questionnaire steps
   */
  return {
    version: FMP_FORM_NAME,
    questions: fmpFormQuestions,
  }
}
